import saudicupApi from "@/api/saudicupApi";
import authHeader from "@/services/saudi-cup/auth/auth-header";
const END_POINT = "api";
class PaymentService {
    prepare_the_checkout(body) {
        return saudicupApi.post(
            `${END_POINT}/prepare-the-checkout`, body, { headers: authHeader() }
        ).then((response) => {
            return response;
        });
    }
    check_payment_result(checkoutId) {
        return saudicupApi.get(
            `${END_POINT}/result/${checkoutId}/1`, { headers: authHeader() }
        ).then((response) => {
            return response;
        });
    }
}
export default new PaymentService();